import React, { memo, useEffect, useMemo, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import { v1 as uuid } from 'uuid';
import PropTypes from 'prop-types';

const Rating = ({ onChange, ratingValue }) => {
  const refs = useRef([
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
  ]);

  const getBackgroundColor = (value) => {
    let background = '#20ba45';
    if (value <= 6) {
      background = '#db2828';
    }
    if (value > 6 && value <= 8) {
      background = '#fbbd09';
    }
    return background;
  };

  const changeRatingColor = (value) => {
    [...new Array(refs.current.length)].forEach((item, index) => {
      if (value !== null && index <= value) {
        refs.current[index].current.style.backgroundColor =
          getBackgroundColor(index);
      } else {
        refs.current[index].current.style.backgroundColor = null;
      }
    });
  };

  const changeRatingColorAndOnChangeValue = (value) => {
    changeRatingColor(value);
    if (value !== ratingValue) {
      onChange(value);
    }
  };

  useEffect(() => {
    changeRatingColor(ratingValue);
  }, [ratingValue]);

  return (
    <>
      {useMemo(
        () => (
          <div className="rating">
            {[...new Array(11)].map((value, index) => {
              return (
                <button
                  ref={refs.current[index]}
                  key={uuid()}
                  type="button"
                  id={`rating-button-${index}`}
                  className="rating-button"
                  onMouseEnter={() => changeRatingColorAndOnChangeValue(index)}
                >
                  {index}
                </button>
              );
            })}
          </div>
        ),
        [ratingValue]
      )}
    </>
  );
};

Rating.propTypes = {
  onChange: PropTypes.func.isRequired,
  ratingValue: PropTypes.number,
};

Rating.defaultProps = {
  ratingValue: null,
};

export default withTranslation('common')(memo(Rating));
